import React from "react"

import { Box } from "@chakra-ui/core"

import LocalTime from "components/LocalTime"

type AcrClassPeriodTableRowProps = {
  data: {
    startsAt: string
    endsAt: string
  }
}

const AcrClassPeriodTableRow: React.FC<AcrClassPeriodTableRowProps> = ({
  data: acrClassPeriod,
}) => (
  <>
    <Box as="td" pl="4" py="3">
      <LocalTime omitDate timestamp={acrClassPeriod.startsAt} />
      &nbsp;&mdash;&nbsp;
      <LocalTime omitDate timestamp={acrClassPeriod.endsAt} />
    </Box>
    <Box as="td" pl="4" py="3">
      <LocalTime omitTime timestamp={acrClassPeriod.startsAt} />
    </Box>
  </>
)

export default AcrClassPeriodTableRow
